import React, { useState, createContext, useEffect } from "react";
import PropTypes from "prop-types";
import CmsApi from "@apis/CmsApi";

const NavContext = createContext();

const NavProvider = ({ children }) => {

    const [subNav, setSubNav] = useState(null);
    const [menuComponents, setMenuComponents] = useState({})

    useEffect(() => {

        new CmsApi().fetchNavComponents([
            'lacantina_home_featured_item',
            'lacantina_product_featured_item',
            'lacantina_gallery1_featured_item',
            'lacantina_gallery2_featured_item',
            'lacantina_learn1_featured_item',
            'lacantina_learn2_featured_item',
            'lacantina_pro1_featured_item',
            'lacantina_pro2_featured_item',
            'lacantina_about1_featured_item',
            'lacantina_about2_featured_item',
            'lacantina_support1_featured_item',
            'lacantina_support2_featured_item',
        ]).then((values) => {

            let menuTiles = {};
            values.map((tile) => {

                let image, image_url, alt_text;
                image = tile?.elements?.find((el) => el.render_name === 'featured_image');
                if (image) {
                    image_url = image?.value?.elements?.find((el) => el.render_name === 'image_url');
                    alt_text = image?.value?.elements?.find((el) => el.render_name === 'alt_text');
                }

                let description = tile?.elements?.find((el) => el.render_name === 'featured_description');

                let link, link_url, link_text;
                link = tile?.elements?.find((el) => el.render_name === 'featured_link');
                if (link) {
                    link_url = link?.value?.elements?.find((el) => el.render_name === 'link_url');
                    link_text = link?.value?.elements?.find((el) => el.render_name === 'link_text');
                }

                if (tile?.slug) {
                    menuTiles[tile.slug] = {
                        image: {
                            image_url: image_url?.value,
                            alt_text: alt_text?.value,
                        },
                        description: description.value,
                        link: {
                            link_url: link_url?.value,
                            link_text: link_text?.value
                        }
                    }


                }

            })

            setMenuComponents(menuTiles);
        });



    }, [])

    return (
        <NavContext.Provider value={{ stickyMenu: [subNav, setSubNav], menuComponents: menuComponents }}>
            {children}
        </NavContext.Provider>
    );
};

NavProvider.propTypes = {
    children: PropTypes.node,
};

export { NavProvider, NavContext };

